const requestActionTypes = {
  RESET_STATE: 'RESET_STATE',
  REQUEST_SSO_LOGIN_REQUEST: 'REQUEST_SSO_LOGIN_REQUEST',
  REQUEST_SSO_LOGIN_SUCCESS: 'REQUEST_SSO_LOGIN_SUCCESS',
  REQUEST_SSO_LOGIN_FAILURE: 'REQUEST_SSO_LOGIN_FAILURE',
};

export { requestActionTypes as default };
